var _defs, _ellipse, _path, _path2, _g, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOnepiece(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 680,
    viewBox: "0 0 800 680",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "domeClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,438 C212,250 276,142 400,142 C524,142 588,250 588,438 Z"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 446,
    rx: 348,
    ry: 118,
    fill: "#E8C275",
    stroke: "#8A5F1E",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,446 A348,118 0 0,0 748,446",
    fill: "#D8AC57",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212,438 C212,250 276,142 400,142 C524,142 588,250 588,438 Z",
    fill: "#F0D290",
    stroke: "#8A5F1E",
    strokeWidth: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#domeClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 352,
    width: 440,
    height: 74,
    fill: "#EC3013"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 352,
    width: 440,
    height: 10,
    fill: "#000",
    opacity: 0.18
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212,352 H588 M212,426 H588",
    stroke: "#8A5F1E",
    strokeWidth: 8,
    fill: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8A5F1E",
    strokeWidth: 6,
    opacity: 0.35,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262,300 C320,262 480,262 538,300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,240 C310,196 490,196 560,240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,190 C350,166 450,166 500,190"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnepiece);
export default __webpack_public_path__ + "static/media/logo-onepiece.a047a9072182fded5e959db67d303b15.svg";
export { ForwardRef as ReactComponent };